export class NewPass {
  password: String;
  passwordConfirm: String;
}
